import Vue from 'vue';

export const errorToaster = async (message: string) => {
  await Vue.swal({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 30000,
    type: "error",
    text: message
  })
}

export async function ajaxGet(url: string, token: string) {
  try {
    var response = await fetch(url, {
      method: 'GET',
      credentials: "same-origin",
      headers: {
        'Accept': 'application/json; odata=verbose',
        'Authorization': 'Bearer ' + token
      },
    });
    if (response.status !== 200) {
      throw new Error(result);
    }
    
    var result = await response.json();
    return result;
  } catch (error) {
    errorToaster(error as string);
    console.log(error);
    if(error.toString().indexOf("Authentication error") > -1){
      return "Authentication error";
    }
    return null;
  }
}
export async function ajaxFileGet(url: string, token: string) {
  try {
    var response = await fetch(url, {
      method: 'GET',
      credentials: "same-origin",

      headers: {
        'Accept': 'application/json; odata=verbose',
        'Authorization': 'Bearer ' + token
      },
    });
    var result = await response.blob();
    if (response.status !== 200) {
      throw new Error();
    }
    return result;
  } catch (error) {
    errorToaster(error as string);
    return null;
  }
}
export async function ajaxGetFileByPost(url: string, token: string, data: object) {
  try {
    var response = await fetch(url, {
      method: 'POST',
      credentials: "same-origin",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json; odata=verbose',
        'Authorization': 'Bearer ' + token
      },
    });
    var result = await response.blob();
    if (response.status !== 200) {
      throw new Error();
    }
    return result;
  } catch (error) {
    errorToaster(error as string);
    return null;
  }
}
export async function ajaxPost(url: string, token: string, data: object) {
  try {
    var response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json;odata=verbose",
        'Authorization': 'Bearer ' + token
      },
      credentials: 'same-origin'
    });
    if (response.status !== 200) {
      var result = await response.json();
      throw new Error(result);
    }
    return !!result ? result : "OK";
  } catch (error) {
    errorToaster(error as string);
    return null;
  }
}
export async function ajaxPostForm(url: string, token: string, data: FormData) {
  try {
    var response = await fetch(url, {
      method: "POST",
      body: data,
      headers: {
        "Accept": "application/json;odata=verbose",
        "enctype": "multipart/form-data",
        'Authorization': 'Bearer ' + token
      },
      credentials: 'same-origin'
    });
    if (response.status !== 200) {
      var result = await response.json();
      throw new Error(result);
    }
    return "OK";
  } catch (error) {
    errorToaster(error as string);
    return null;
  }
}
export async function ajaxPut(url: string, token: string, data: object) {
  try {
    var response = await fetch(url, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json;odata=verbose",
        'Authorization': 'Bearer ' + token
      },
      credentials: 'same-origin'
    });
    if (response.status !== 200) {
      var result = await response.json();
      throw new Error(result);
    }
    return "OK";
  } catch (error) {
    errorToaster(error as string);
    return null;
  }
}

export async function ajaxDelete(url: string, token: string) {
  try {
    var response = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json;odata=verbose",
        'Authorization': 'Bearer ' + token
      },
      credentials: 'same-origin'
    });
    if (response.status !== 200) {
      var result = await response.json();
      throw new Error(result);
    }
    return "OK";
  } catch (error) {
    errorToaster(error as string);
    return null;
  }
}